(() => {
  'use strict';

  const START = Date.parse('2026-08-31T22:00:00Z');
  const END = Date.parse('2026-10-15T22:00:00Z');
  const FREE_SHIPPING_CENTS = 2695;
  const DISCOUNT = 0.10;

  const active = () => Date.now() >= START && Date.now() < END;
  const money = cents => new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(cents / 100);
  const discounted = cents => Math.round(cents * (1 - DISCOUNT));

  function setMoney(root, selector, cents) {
    const node = root.querySelector(selector);
    if (node) node.textContent = money(cents);
  }

  function patchProductPage() {
    if (!active()) return;
    const productRoot = document.querySelector('.product-single[data-product-handle="piccolinoos"]');
    if (!productRoot) return;

    const regular = 2995;
    const promo = discounted(regular);
    const price = productRoot.querySelector('#ProductPrice');
    const compare = productRoot.querySelector('#ComparePrice');
    if (price) {
      price.classList.add('on-sale', 'text-sale');
      price.setAttribute('content', (promo / 100).toFixed(2));
      setMoney(price, '.money', promo);
    }
    if (compare) {
      compare.classList.remove('hide');
      setMoney(compare, '.money', regular);
    }

    const incl = productRoot.querySelector('.include-text p');
    if (incl) incl.textContent = 'inkl. MwSt. · kostenloser Versand während der Launch-Aktion';

    const packs = [
      { qty: '1', regular: 2995, unitDivisor: 1 },
      { qty: '2', regular: 5290, unitDivisor: 2, referenceRegular: 5990 },
      { qty: '3', regular: 7790, unitDivisor: 3, referenceRegular: 8985 }
    ];
    packs.forEach(({ qty, regular: packRegular, unitDivisor, referenceRegular }) => {
      const card = document.querySelector(`.pc-pack-card[data-pc-pack="${qty}"]`);
      if (!card) return;
      const packPromo = discounted(packRegular);
      const priceNode = card.querySelector('.pc-pack-price');
      if (priceNode) {
        priceNode.innerHTML = `<span class="pc-launch-price">${money(packPromo)}</span><s class="pc-launch-was">${money(packRegular)}</s>`;
      }
      const unit = card.querySelector('.pc-pack-unit');
      if (unit) unit.textContent = `${money(Math.round(packPromo / unitDivisor))} pro Set`;
      if (referenceRegular) {
        const saving = card.querySelector('.pc-pack-saving');
        if (saving) saving.textContent = `${money(referenceRegular - packPromo)} sparen inkl. Launch`;
      }
    });

    const foot = document.querySelector('.pc-pack-foot');
    if (foot) foot.innerHTML = '<strong>Bis einschließlich 15.10.2026 · Ab 4 Sets: zusätzlich 10 % Launch-Rabatt auf 24,95 € pro Set.</strong> Designs lassen sich durch das Kombinieren mehrerer Sets mischen; die Auswahl bleibt als Bestellinformation erhalten.';

    document.querySelectorAll('.md-launch-promo--product .md-launch-promo__note').forEach(node => {
      node.textContent = 'Der 10 % Launch-Rabatt ist bereits in den angezeigten Aktionspreisen berücksichtigt und wird automatisch angewendet. Kein Rabattcode nötig.';
    });
  }

  function patchGoalWidgets(cart) {
    if (!active() || !cart) return;
    const total = Number(cart.total_price || 0);
    const remaining = Math.max(0, FREE_SHIPPING_CENTS - total);
    const reached = remaining === 0;

    document.querySelectorAll('.progress-section .task-progress').forEach(root => {
      const text = root.querySelector('p');
      const bar = root.querySelector('progress');
      if (text) text.innerHTML = reached
        ? 'Du hast kostenlosen Versand freigeschaltet!'
        : `Dir fehlen noch <b>${money(remaining)}</b> zum kostenlosen Versand.`;
      if (bar) bar.value = reached ? 100 : Math.min(100, (total * 100) / FREE_SHIPPING_CENTS);
    });

    document.querySelectorAll('.versand-wrapper .money').forEach(node => {
      if (reached) {
        node.textContent = 'Kostenlos';
        node.style.color = 'green';
      } else {
        node.style.color = '';
      }
    });

    document.querySelectorAll('.dbtfy-cart_goal').forEach(root => {
      root.dataset.goalAmount = '26.95';
      const text = root.querySelector('.cg-free-shipping-text');
      const bar = root.querySelector('.cg-progress-bar');
      if (text) text.textContent = reached ? 'Du hast kostenlosen Versand freigeschaltet!' : `Dir fehlen noch ${money(remaining)} zum kostenlosen Versand.`;
      if (bar) bar.style.width = `${reached ? 100 : Math.min(100, (total * 100) / FREE_SHIPPING_CENTS)}%`;
    });
  }

  let timer;
  function refreshCartPresentation(cart) {
    if (!active()) return;
    if (cart) {
      patchGoalWidgets(cart);
      return;
    }
    window.clearTimeout(timer);
    timer = window.setTimeout(() => {
      fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } })
        .then(r => r.ok ? r.json() : Promise.reject(new Error(`cart ${r.status}`)))
        .then(patchGoalWidgets)
        .catch(err => console.warn('Launch cart presentation update failed', err));
    }, 40);
  }

  function start() {
    if (!active()) return;
    patchProductPage();
    refreshCartPresentation();

    const cartContainer = document.getElementById('CartContainer');
    if (cartContainer && window.MutationObserver) {
      new MutationObserver(() => refreshCartPresentation()).observe(cartContainer, { childList: true, subtree: true });
    }
    if (window.jQuery) {
      window.jQuery(document).on('ajaxCart.afterCartLoad.modaleenLaunchConsistency', (_event, cart) => refreshCartPresentation(cart));
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
